import script from "./GetStartedEntryPoint.vue?vue&type=script&setup=true&lang=js"
export * from "./GetStartedEntryPoint.vue?vue&type=script&setup=true&lang=js"

import "./GetStartedEntryPoint.vue?vue&type=style&index=0&id=6e411ef2&scoped=true&lang=css"

import exportComponent from "/Users/ben/Local Sites/serenialife-public/app/public/wp-content/themes/serenialife-public-theme/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6e411ef2"]])

export default __exports__